var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "apartment-selector" }, [
    _c("div", { staticClass: "wrapper-lg" }, [
      !_vm.mobile
        ? _c(
            "div",
            _vm._l(_vm.apartments, function(apartment) {
              return apartment.status.toLowerCase() !== "sprzedane"
                ? _c("apartment-tooltip", {
                    key: apartment.id,
                    attrs: { apartment: apartment }
                  })
                : _vm._e()
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "svg",
        {
          attrs: {
            width: "100%",
            height: "922",
            viewBox: "0 0 1440 922",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c("image", {
            attrs: {
              id: "osiedle-nad-stawem_4",
              x: "0",
              y: "0",
              width: "1440",
              height: "922",
              "xlink:href":
                "https://tarasynadstawem.pl/app/uploads/2025/10/osiedle-nad-stawem-selector-scaled-1.jpg"
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.points, function(apartment) {
            return _vm.hasApartment(apartment.id)
              ? _c("path", {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        html: "#" + apartment.id,
                        interactive: false,
                        delay: [0, 0],
                        animateFill: false,
                        interactiveBorder: 0,
                        theme: "light",
                        followCursor: true,
                        placement: "right-end"
                      },
                      expression:
                        "{\n          html: `#${apartment.id}`,\n          interactive: false,\n          delay: [0, 0],\n          animateFill: false,\n          interactiveBorder: 0,\n          theme: 'light',\n          followCursor: true,\n          placement: 'right-end',\n        }"
                    }
                  ],
                  key: apartment.id,
                  class:
                    "selector-item selector-item--" +
                    _vm.getClassForElement(apartment.id),
                  attrs: { "fill-opacity": "0.4", d: apartment.path },
                  on: {
                    click: function($event) {
                      return _vm.handleApartmentSelection(apartment.id)
                    }
                  }
                })
              : _vm._e()
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-674d2faa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-674d2faa","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!/Users/mrkaluzny/Developer/tarasy-nad-stawem/web/app/themes/tarasy-nad-stawem/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/components/Selector.vue
// module id = 46
// module chunks = 0